module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAyUlEQVQ4jb2TUQ3DMAxEHwRDKIRACIRCKIRACINCKIRCGIRBGYV95CK5bapm67STrKhOfD6fVfgj7FdEWXEbM7DcJRkVEZjuqqkerZ8UGjAAQQqyu5ucuuGMYAKeUpD0XQv81uqoSU1eNEbOHLcTXZPnTklSNBHZemFS6b0yNTwo2SOIzHSubH1ZKON1IYtoZGuyAY9eEiijVOx/kbmRa6KuHqlYKOMF5aq6SyQVZRGay88Ur0635bFSfAiNu+AUXmLoeBN7iL7CG7xLJUdaHWG4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/header/kongjian.png
// module id = NwLr
// module chunks = 1